var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 4.2404H15V3.40706C15 2.94873 14.625 2.57373 14.1667 2.57373C13.7083 2.57373 13.3333 2.94873 13.3333 3.40706V4.2404H6.66667V3.40706C6.66667 2.94873 6.29167 2.57373 5.83333 2.57373C5.375 2.57373 5 2.94873 5 3.40706V4.2404H4.16667C3.24167 4.2404 2.50833 4.9904 2.50833 5.90706L2.5 17.5737C2.5 18.4904 3.24167 19.2404 4.16667 19.2404H15.8333C16.75 19.2404 17.5 18.4904 17.5 17.5737V5.90706C17.5 4.9904 16.75 4.2404 15.8333 4.2404ZM15.8333 16.7404C15.8333 17.1987 15.4583 17.5737 15 17.5737H5C4.54167 17.5737 4.16667 17.1987 4.16667 16.7404V8.40706H15.8333V16.7404ZM5.83333 10.0737H7.5V11.7404H5.83333V10.0737ZM9.16667 10.0737H10.8333V11.7404H9.16667V10.0737ZM12.5 10.0737H14.1667V11.7404H12.5V10.0737Z",
    fill: "#6138F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.76dc39d0773773d4b01fa3ed3c581734.svg";
export { ForwardRef as ReactComponent };